/* eslint-disable camelcase */
export default {
  email_not_unique: "Пользователь с таким email уже существует",
  phone_not_unique: "Пользователь с таким номером телефона уже существует",
  account_created: "Аккаунт успешно создан",
  id_of_created_user: "ID созданного пользователя",
  unknown_uniqueness_error: "Произошла неизвестная ошибка при проверки уникальности",
  unknown_create_error: "Произошла неизвестная ошибка при создании аккаунта",
};
